import * as TYPES from "./Timeline.types";

export const fetchTimeline = () => ({
  types: [
    TYPES.FETCH_TIMELINE,
    TYPES.FETCH_TIMELINE_SUCCESS,
    TYPES.FETCH_TIMELINE_FAIL,
  ],
  promise: (client) => client.get("/timeline"),
});

export const setChapterStep = (step) => ({
  types: [
    TYPES.SET_CHAPTER_STEP,
    TYPES.SET_CHAPTER_STEP_SUCCESS,
    TYPES.SET_CHAPTER_STEP_FAIL,
  ],
  promise: () => new Promise((resolve) => resolve(step)),
});

export const setChapterSlideStep = (step) => ({
  types: [
    TYPES.SET_CHAPTER_SLIDE_STEP,
    TYPES.SET_CHAPTER_SLIDE_STEP_SUCCESS,
    TYPES.SET_CHAPTER_SLIDE_STEP_FAIL,
  ],
  promise: () => new Promise((resolve) => resolve(step)),
});

export const setCurrentChapter = (chapter = {}) => ({
  types: [
    TYPES.SET_CURRENT_CHAPTER,
    TYPES.SET_CURRENT_CHAPTER_SUCCESS,
    TYPES.SET_CURRENT_CHAPTER_FAIL,
  ],
  promise: () => new Promise((resolve) => resolve(chapter)),
});
